(function() {
    'use strict';

    angular
        .module('mlcccApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
